import React from 'react'
import Popup from 'reactjs-popup'
import { HoverSensor } from 'libreact/lib/HoverSensor'
import styled, { withTheme } from 'styled-components'
import { WindowWidthSensor } from 'libreact/lib/WindowWidthSensor'
import { ReactComponent as QuestionIcon } from '../assets/question.svg'
import { ReactComponent as QuestionHoverIcon } from '../assets/question-dark.svg'
import CloseButton from './CloseButton'

const Icon = styled.div`
  height: 14px;
  width: 14px;
  fill: ${props => props.theme.colors.grey5};
  cursor: pointer;

  &:hover {
    fill: ${props => props.theme.colors.grey4};
  }

  @media (max-width: 768px) {
    height: 18px;
    width: 18px;
  }
`

const Trigger = (props) => (
  <span {...props}>
    <HoverSensor>
      {({ isHover }) => (
        <Icon as={isHover ? QuestionHoverIcon : QuestionIcon} />
      )}
    </HoverSensor>
  </span>
)

const Description = styled.div`
  color: ${props => props.theme.colors.grey2};
  font-size: 15px;
  line-height: 1.5;
  font-weight: 400;
`

const Content = styled.div`
  padding: 20px 20px;
`

const Headline = styled.div`
  font-weight: 600;
  font-size: 18px;
  padding-bottom: 10px;
  padding-right: 20px;
`

const styles = (theme) => ({
  content: {
    border: 0,
    borderRadius: theme.borderRadius.light,
    textAlign: 'left',
    fontSize: '14px',
    width: '100%',
    maxWidth: '350px',
  },
  overlay: {
    backgroundColor: theme.colors.grey11transparent,
    zIndex: 1,
  },
})

export default withTheme(({ label, description, className, theme }) => (
  <WindowWidthSensor>
    {({ width }) => {
      const small = width < 768

      return (
        <div className={className}>
          <Popup
            contentStyle={styles(theme).content}
            overlayStyle={styles(theme).overlay}
            trigger={<Trigger />}
            on={small ? 'click' : 'hover'}
            modal={small}
            position={['bottom center', 'bottom left', 'bottom right']}
          >
            {close => (
              <>
                {small && <CloseButton onClick={close} />}
                <Content>
                  {small && <Headline>
                    {label}
                  </Headline>}
                  <Description>
                    {description}
                  </Description>
                </Content>
              </>
            )}
          </Popup>
        </div>
      )
    }}
  </WindowWidthSensor>
))
